(function () {

  'use strict';


  eclipseApp.factory( 'transactionHistoryService' , function(){

      var response = null;

      function setResponse(data) {
        response = data;
      }

      function getResponse() {
        return response;
      }

      return {
        setResponse: setResponse,
        getResponse: getResponse
      };


  });


})();
